// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 19) return "static/js/8961ff220cc775953a0b.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"6e887bc448c900082134","116":"7b3fb098aa80acbd3bfa","117":"7a540624fe742384254a"}[chunkId] + ".chunk.js";
};